import { Grid, LinearProgress, Typography } from "@mui/material";
import { PrimaryButton } from "../button/primary.button";

export function PageHeader(params: {
    pageName: string,
    buttonName?: string,
    onClick?: () => void;
    isLoading?: boolean,
    actionType?: "create" | "back" | "edit"
}) {

    return (
        <>
            <Grid container direction="row" justifyContent="space-between" mb={1}>
                <Grid>
                    <Typography variant="h5" color="primary">{params.pageName}</Typography>
                </Grid>

                {!!params.buttonName &&
                    <Grid>
                        <PrimaryButton
                            type="button"
                            icon={params.actionType === "create" ? "add" : params.actionType === "edit" ? "edit" : "arrow_back"}
                            variant="primary"
                            onClick={params.onClick}
                        >{params.buttonName}
                        </PrimaryButton>
                    </Grid>
                }
            </Grid>

            {params.isLoading && <LinearProgress />}

        </>
    );

}
